import { render, staticRenderFns } from "./TkQueryCard.vue?vue&type=template&id=199bfed2&scoped=true&"
import script from "./TkQueryCard.vue?vue&type=script&lang=js&"
export * from "./TkQueryCard.vue?vue&type=script&lang=js&"
import style0 from "./TkQueryCard.vue?vue&type=style&index=0&id=199bfed2&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199bfed2",
  null
  
)

export default component.exports